import React, {useEffect} from 'react'
import {useForm} from "react-hook-form";
import Card from "../../components/forms/Card";
import FormGroup from "../../components/forms/FormGroup";
import Input from "../../components/forms/FormEl";
import {Col, Row} from "../../components/flex/FlexLayout";
import Button from "../../components/forms/Button";
import ConsejerosFormSelect from "../../components/selects/ConsejerosFormSelect";
import SwitchToggle from "../../components/layout/SwitchToggle";
import ConsejeriasFormSelect from "../../components/selects/ConsejeriasFormSelect";
const SinAtencionForm = ({value, onSubmit}) => {

  const {register, handleSubmit, formState: {errors}, reset, watch, setValue} = useForm(
    {defaultValues: {...value,feriado: false}}
  );

  useEffect(() => {
    if (value) {
      reset(value)
    }
  }, [value])

  const watchFeriado = watch("feriado")

  useEffect(() => {
    if(watchFeriado) {
      setValue("usuarioId",null)
      setValue("consejeriaId",null)
    }
  }, [watchFeriado])

  return (
    <form>

      <Card padding>

        <FormGroup>
          <label>Es feriado</label>
          <SwitchToggle
            size={24}
            label={""}
            {...register("feriado")}
          />
        </FormGroup>

        <FormGroup>
          <label>Consejero</label>
          <ConsejerosFormSelect disabled={watchFeriado} {...register("usuarioId")}/>
        </FormGroup>

        <FormGroup>
          <label>Consejeria</label>
          <ConsejeriasFormSelect disabled={watchFeriado} {...register("consejeriaId")}/>
        </FormGroup>
      </Card>

      <Card padding>

        <Row>
          <Col>
            <FormGroup>
              <label>Fecha inicio</label>
              <Input type='datetime-local' {...register("fechaInicio",
                {
                  required: "Campo obligatorio"
                })}/>
              {errors.fechaInicio && <p style={{color: 'red'}}>{errors.fechaInicio?.message}</p>}
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <label>Fecha fin</label>
              <Input type='datetime-local' {...register("fechaFin",
                {
                  required: "Campo obligatorio"
                })}/>
              {errors.fechaFin && <p style={{color: 'red'}}>{errors.fechaFin?.message}</p>}
            </FormGroup>
          </Col>
        </Row>

        <FormGroup>
          <label>Motivo</label>
          <Input type='text' {...register("motivo")}/>
        </FormGroup>
      </Card>

      <Button variant={'primary'} onClick={handleSubmit(onSubmit)}>Guardar</Button>
    </form>
  )
}

export default SinAtencionForm;
